import { Link } from 'react-router-dom';

const gaps = [
  { skill: 'System Design at Scale', status: 'You have this', kind: 'have' },
  { skill: 'Stakeholder Storytelling', status: 'SPARK Framework', kind: 'need' },
  { skill: 'AI Code Review Discipline', status: 'Vibe Engineering', kind: 'need' },
  { skill: 'Cloud Fundamentals', status: 'You have this', kind: 'have' },
];

function HomeJobsTeaserSection() {
  return (
    <section className="band jobs" id="jobs" aria-labelledby="jobs-title">
      <div className="wrap jobs-grid">
        <div>
          <p className="eyebrow" style={{ color: '#FF8C7E' }}>Coming Soon - The Jobs Board</p>
          <h2 id="jobs-title" style={{ marginTop: '14px' }}>
            Find Your Next Role.<br /><span className="red">Know Exactly How to Get There.</span>
          </h2>
          <p>Browse curated tech roles and see, for each one, the exact skills the job requires versus what you already have. No guesswork. No generic advice.</p>
          <p>If there&#39;s a gap, we&#39;ll tell you which program closes it- so you walk into your next interview with proof, not just intent.</p>
          <Link className="btn btn-red" to="/jobs">Browse Open Roles</Link>
        </div>
        <div className="jobs-panel">
          <div className="panel-title">Example role</div>
          <div className="role-name">Senior Software Architect</div>
          {gaps.map((g) => (
            <div className="gap-row" key={g.skill}>
              <span className="skill">{g.skill}</span>
              <span className={`gap-tag gap-${g.kind}`}>{g.status}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeJobsTeaserSection;
